import { Box, Text } from '@factorialco/deprecated-design-system'
import type { TeamQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import type { ITeam } from 'modules/teams/store/models/Team'

import TeamList from './List'

type TeamMembership = NonNullable<NonNullable<TeamQuery['teams']['team']>['memberships']>[number]

interface Props {
  team: ITeam
  readonly?: boolean
  memberships: TeamMembership[]
  hasDevJobCatalogTree: boolean
}

const Members = ({ team, readonly, memberships, hasDevJobCatalogTree }: Props) => {
  return (
    <Box>
      <Box paddingBottom="s16">
        <Text.Normal color="grey1000" weight="medium" size="200">
          {i18n.t('employees.common.team_members')}
        </Text.Normal>
      </Box>
      <TeamList
        team={team}
        readonly={readonly}
        memberships={memberships}
        hasDevJobCatalogTree={hasDevJobCatalogTree}
      />
    </Box>
  )
}

export default Members
